import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from "@vueuse/core";
import { Separator } from "reka-ui";
import { cn } from '../../primitives/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Separator',
    props: {
        orientation: { type: String, required: false, default: "horizontal" },
        decorative: { type: Boolean, required: false, default: true },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, "class");
        const __returned__ = { props, delegatedProps, get Separator() { return Separator; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
